// @ts-nocheck
import { AccordionStyle } from "@insite/mobius/Accordion/Accordion";
import { AccordionSectionPanel, AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import getColor from "@insite/mobius/utilities/getColor";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import Minus, { MinusOffset } from "@store/Library/Components/Toolkit/Icons/Minus";
import Plus, { PlusOffset } from "@store/Library/Components/Toolkit/Icons/Plus";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import { iconScalableStyles } from "@toolkit/Themes/common/mixins/icon";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { typographyTitleStyles } from "@store/Themes/common/mixins/typography";
/* Store Custom Code - End */

const borderWidth = "1px";
const borderCss = css`
    ${({ theme }) => `${borderWidth} solid ${resolveColor("common.border", theme)}`}
`;

const _headerButtonBaseStyles = () => {
    return css`
        ${focusStyles()}
        ${typographyTitleStyles(pxToRemArray([30, null, null, null, 35]))}
        padding: ${pxToRem(16, 0)};
        background-color: ${getColor("common.background")};
        border: ${borderCss}; /* Store Custom Code */
        /* Store Removed - border-top, border-bottom */
        color: inherit;
        transition: ${transitionHoverStyles("color")};
        text-transform: uppercase; /* Store Custom Code */

        ${({ theme }) => css`
            ${breakpointValues(theme.design.accordion.padding.vertical, ["padding-top", "padding-bottom"])}
            ${breakpointValues(theme.design.accordion.padding.horizontal, ["padding-right", "padding-left"])}
            /* Store Removed - font-size */
            font-weight: ${theme.design.typography.weight.extrabold}; /* Store Custom Code */
            line-height: ${theme.design.typography.lineHeight.small};
        `}

        &:hover {
            color: ${getColor("primary.main")};
        }

        /* Store Removed - breakpoint */
    `;
};

const _headerButtonStyles = () => {
    return css`
        button {
            ${_headerButtonBaseStyles()}

            &:focus,
            &:focus-visible {
                ${_headerButtonBaseStyles()}
            }
        }
    `;
};

export const accordionProductDetailsSectionProps: AccordionSectionPresentationProps = {
    headerProps: {
        css: css`
            ${_headerButtonStyles()}

            /* Store Custom Code - Start */
            ${AccordionSectionPanel} + && {
                > button {
                    border-top: none !important;
                }

                ${_headerButtonStyles()}
            }
            /* Store Custom Code - End */
        `,
    },
    panelProps: {
        css: css`
            ${({ theme }) => css`
                ${breakpointValues(theme.design.accordion.padding.horizontal, "padding")}
                ${breakpointValues(theme.design.accordion.padding.vertical, "padding-top")}
            `}
            background-color: ${getColor("common.background")};
            border: ${borderCss};
            border-top: none; /* Store Custom Code */

            /* Store Removed - last-of-type  */
        `,
    },
    expandIconProps: {
        src: Plus,
        color: "inherit",
        css: css`
            ${iconScalableStyles(pxToRem(20), PlusOffset)}
            margin-left: 1em;
        `,
    },
    collapseIconProps: {
        src: Minus,
        color: "inherit",
        css: css`
            ${iconScalableStyles(pxToRem(20), MinusOffset)}
            margin-left: 1em;
        `,
    },
    // Store Custom Code
    toggleTransition: {
        transitionCss: css`
            bottom: -10px;
        `,
    },
};
